<div class="border container col-lg-5 col-sm-8 ms-4 me-4">
  Kontrollera att personen inte finns i systemet sedan tidigare.
  <br>
  <p class="infotext">{{infoText}}</p>
  <br>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <label>Födelsedatum</label>
    <div class="d-flex justify-content-start gap-2">
      <input type="text" class="form-control form-control-sm" style="max-width:120px;" formControlName="Birth" mask="0000-00-00" placeholder="YYYY-mm-dd">
      <button *ngIf="activeBtn==='Kontrollera'" class="btn border" [disabled]="!form.valid" (click)="checkUser()" style="margin-left:10px;">Kontrollera</button>
      <button *ngIf="activeBtn==='Fortsätt'" class="btn border" (click)="continue()" style="margin-left:10px;">Fortsätt</button>
      <button class="btn border" style="margin-left:10px;" *ngIf="activeBtn==='Fortsätt'" (click)="form.get('Birth').setValue(null);activeBtn='Kontrollera';form.get('Birth').setValue(null)">Byt datum</button>
      <button class="btn border" (click)="cancel();activeBtn=null" style="margin-left:10px;">Avbryt</button>
    </div>
  </form>
  <div class="row mt-3">
    <div id="accordion" class="col-sm-12" *ngFor="let m of members;let i = index">
      <div class="card">
        <div class="card-header collapsed" data-toggle="collapse" [attr.data-target]="'#collapse' + i">
          <div class="card-link">{{m.givenName}} {{m.familyName}}</div>
        </div>
        <div id="{{ 'collapse' + i }}" class="collapse">
          <div class="card-body">
            <app-memberdetails [member]=m></app-memberdetails>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>